
























import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "../GGGroup/GGGroup.vue";
import type { PageData } from "@constructor/shared-entity/type";
import type { UserCart } from "../../../type/UserCart";
import type { SectionMeta } from "../../../type/SectionMeta";
import MPRowSlider from "../marketplace/MPRowSlider/MPRowSlider.vue";

export default defineComponent({
  name: "GGScrollBar",
  components: {
    GGGroup,
    MPRowSlider,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
    userCart: {
      type: Object as PropType<UserCart>,
      required: true,
    },
    meta: {
      type: Object as PropType<SectionMeta>,
      default: () => ({}),
    },
  },
  emits: {
    "cart-add": (_: string) => true,
    "cart-remove": (_: string) => true,
    "auth-needed": () => true,
  },
});
